export const RECENT_KEYWORD_LIST_MAX_LENGTH = 10;
